import { render, staticRenderFns } from "./VerRetornoDatasGlosa.vue?vue&type=template&id=792efa14&"
import script from "./VerRetornoDatasGlosa.vue?vue&type=script&lang=js&"
export * from "./VerRetornoDatasGlosa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports